import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup
  .object({
    expenseName: yup.string().required("Expense name is required"),
    store: yup.string().required("Store is required"),
    //account: yup.string().required("Account is required"),
    amount: yup.string().required("Amount is required"),
    category: yup.string().required("Category is required"),
    paymentMethod: yup.string().required("Payment method is required"),
    expenseDate: yup.string().required("Expense date is required"),
  })
  .required("All fields are required");

const Validation = ({ expenseDetails }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      expenseName: expenseDetails?.name,
      store: expenseDetails?.store,
      //  account: expenseDetails?.ledger_account_id,
      amount: expenseDetails?.amount,
      category: expenseDetails?.category,
      paymentMethod: expenseDetails?.payment_method,
      expenseDate: expenseDetails?.expense_date,
    },
  });
};

export default Validation;
